<template>
  <vs-card class="cardx">
    <div slot="header" style="padding:10px">
      <h3>
        Orders
      </h3>
    </div>
    <div>
      <orders :filters="filters" />
    </div>
  </vs-card>
</template>

<script>
  import Orders from "../orders/data";

  export default {
    name: "CustomerOrders",
    components: {
      orders: Orders
    },
    data(){
      return {
        filters : {}
      }
    }
  }
</script>

<style scoped>

</style>
